import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-cursor"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "figure__caption" }


const __default__ = { name: 'PersonComponent' };

import { PropType } from 'vue';
import SVGPlay from '@/svgs/play.svg';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  src: {
    type: String,
    default: '',
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  subtext: {
    type: String,
    default: '',
  },
  preventMask: {
    type: Boolean,
    default: false,
  },
  hasVideo: {
    type: Boolean,
    default: false,
  },
  isCircle: {
    type: Boolean,
    default: false,
  },
  click: {
    type: Function as PropType<(event: MouseEvent) => void>,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    class: _normalizeClass(["figure", [__props.preventMask && 'no-mask', __props.isCircle && 'is-circle']]),
    "data-cursor": __props.click ? 'standard' : undefined
  }, [
    (__props.click)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          to: "about",
          class: "figure__link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.click && __props.click(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["figure__container", [__props.click && 'has-click', __props.isCircle && 'is-circle']])
    }, [
      (__props.hasVideo && __props.click)
        ? (_openBlock(), _createBlock(_unref(SVGPlay), {
            key: 0,
            class: "figure__play"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: __props.src,
        alt: __props.title,
        class: "figure__image"
      }, null, 8, _hoisted_2)
    ], 2),
    _createElementVNode("figcaption", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(__props.subtext), 1)
    ])
  ], 10, _hoisted_1))
}
}

})